import {
  rangeValidation,
  quantitiesValidation,
  panelizedValidation,
  hasArrayValidation,
  railWidthValidation,
  partNumberValidation,
  revisionValidation,
  zipFileValidation,
} from 'pu-data/Validations';

export const productKeyDescription = (productkey) => {
  switch (productkey) {
    case 'fabrication-us-quickturn':
      return 'Pentalogix';
    case 'fabrication-us-excell':
      return 'Excell';
    case 'fabrication-us-ampel':
      return 'Ampel';
    case 'fabrication-offshore-whx':
    case 'fabrication-offshore-whx-covid19':
      return 'WHX';
    default:
      return productkey;
  }
};

export const extractVendorNames = (quote) => {
  if (!quote || !quote.line_items) return null;

  const productRefs = quote.line_items.map((li) => _.replace(li.quote_config_key, /(-grpa)|(-grpb)/g, ''));
  return productRefs.filter((vendor) => vendor !== 'whx' && vendor !== 'panel-share')
};


export const basicParams = {
  material_type: 'FR4TG180',
  // finish_plating  : 'ENIG',
  copper_inners: '1 oz',
  copper_outers: '1 oz',
  solder_color: 'green',
  solder_sides: 'Both Sides',
  silkscreen_color: 'White',
  material_thickness: '0.062',
};

export const validateParametersRules = {
  board_length: (name) => rangeValidation('Board Length', name, 0.1, 20),
  board_width: (name) => rangeValidation('Board Width', name, 0.1, 33),
};

export const aditionalRules = {
  quantities: quantitiesValidation,
  isPanelized: panelizedValidation,
  array_x: (parameters) => hasArrayValidation('Array X', 'array_x', parameters),
  array_y: (parameters) => hasArrayValidation('Array Y', 'array_y', parameters),
  array_up: (parameters) => hasArrayValidation('Array Up', 'array_up', parameters),
  array_x_qty: (parameters) => hasArrayValidation('Array X Qty', 'array_x_qty', parameters),
  array_y_qty: (parameters) => hasArrayValidation('Array Y Qty', 'array_y_qty', parameters),
  array_spacing_x: (parameters) => hasArrayValidation('Spacing in X', 'array_spacing_x', parameters),
  array_spacing_y: (parameters) => hasArrayValidation('Spacing in Y', 'array_spacing_y', parameters),
  railWidth: railWidthValidation,
};

export const extraValidationRules = {
  part_number: (name) => partNumberValidation('Part Number', name),
  revision: (name) => revisionValidation('Revision', name),
  gerber_file_name: (name) => zipFileValidation('Gerber File', name),
}
